import { anyResourceEnabledAtomFactory } from "@/modules/api/resourceTypes.tsx";
import { setSectionsAtom, type Section } from "@/modules/main/sidebar/Sidebar.store.tsx";
import { delayed } from "@/utils/promise/delayed.ts";
import { Trans } from "@lingui/react/macro";
import { atom } from "jotai/vanilla";
import { lazyWithPreload } from "react-lazy-with-preload";

const sections: Section[] = [
    {
        id: "dashboard",
        to: "/",
        // NB: No `routePrefix`
        label: <Trans>Dashboard</Trans>,
        icon: "jp-view-apps-icon",
    },
    {
        id: "compute",
        component: lazyWithPreload(() => delayed(import("@/modules/compute/VmList.tsx"))),
        routePrefix: "/compute",
        label: <Trans>Compute</Trans>,
        icon: "jp-compute-cloud-icon",
        enabledAtom: anyResourceEnabledAtomFactory(["virtual_machine"]),
    },
    {
        id: "disks",
        component: lazyWithPreload(() => delayed(import("@/modules/disks/DiskList.tsx"))),
        routePrefix: "/disks",
        label: <Trans>Disks</Trans>,
        icon: "jp-ssd-disk-icon",
        enabledAtom: anyResourceEnabledAtomFactory(["disk"]),
    },
    {
        id: "metal",
        component: lazyWithPreload(() => delayed(import("@/modules/metal/MetalList.tsx"))),
        routePrefix: "/metal",
        label: <Trans>Bare metal</Trans>,
        icon: "jp-host-icon",
        enabledAtom: anyResourceEnabledAtomFactory(["bare_metal"]),
    },
    {
        id: "storage",
        component: lazyWithPreload(() => delayed(import("@/modules/storage/StorageList.tsx"))),
        routePrefix: "/storage",
        label: <Trans>Storage</Trans>,
        icon: "jp-stack-icon",
        enabledAtom: anyResourceEnabledAtomFactory(["bucket"]),
    },
    {
        id: "network",
        component: lazyWithPreload(() => delayed(import("@/modules/network/NetworkList.tsx"))),
        routePrefix: "/network",
        label: <Trans>Network</Trans>,
        icon: "jp-network-icon",
        enabledAtom: anyResourceEnabledAtomFactory(["vpc", "ip_address", "load_balancer"]),
    },
    {
        id: "services",
        component: lazyWithPreload(() => delayed(import("@/modules/services/ServicesList.tsx"))),
        routePrefix: "/services",
        label: <Trans>Services</Trans>,
        icon: "jp-services-icon",
        enabledAtom: anyResourceEnabledAtomFactory(["managed_service"]),
    },
    {
        id: "access",
        component: lazyWithPreload(() => delayed(import("@/modules/access/AccessList.tsx"))),
        routePrefix: "/access",
        label: <Trans>Access</Trans>,
        icon: "jp-access-icon",
        enabledAtom: anyResourceEnabledAtomFactory(["access_delegation", "api_token"]),
    },
    {
        id: "billing",
        component: lazyWithPreload(() => delayed(import("@/modules/billing/BillingList.tsx"))),
        // No `routePrefix` to prevent billing from opening when creating the first billing account
        // routePrefix: "/billing",
        label: <Trans>Billing</Trans>,
        icon: "jp-card-icon",
        enabledAtom: anyResourceEnabledAtomFactory(["billing_account"]),
    },
];

const sectionsAtom_internal = atom((get) => {
    // NB: the actual sections are constants since Jotai works best when references are stable (otherwise unnecessary re-renders occur)
    return sections.filter(({ enabledAtom }) => enabledAtom == null || get(enabledAtom));
});

export function initSections() {
    setSectionsAtom(sectionsAtom_internal);
}
